var $form = $('form.cupom-desconto');

if (0 != $form.length) {

	const Cupom = require('./models/cupom');

	var cupom = $form.data();
	Cupom.set(cupom);

	const ViewDesconto = require('./views/desconto');
	new ViewDesconto({
		el: $form
	});

}


//////////////////
// WEBPACK FOOTER
// ../src/carrinho/desconto.js
// module id = 66
// module chunks = 0